// Lib
import { produce } from 'immer';

// Utils
import { getTimestamp } from '../../../common/utils/timeUtil';
import { getPersistedDebugToolSettings } from './debugToolStorage';

// Constants
import { DebugToolActionTypes } from './debugToolActionTypes';

// Types
import type { DebugToolAction, DebugToolUpdateAction } from './debugToolActionTypes';
import type { DebugToolState } from './debugToolTypes';

const initialState: DebugToolState = getPersistedDebugToolSettings();

const handleDebugToolUpdate = (state: DebugToolState, action: DebugToolUpdateAction): DebugToolState => {
    const { toolName, user, type, ...rest } = action;

    return produce(state, (draft) => {
        draft[toolName] = {
            ...draft[toolName],
            lastUpdateTimestamp: getTimestamp(),
            ...rest,
        };
    });
};

export default (state: DebugToolState = initialState, action: DebugToolAction): DebugToolState => {
    switch (action.type) {
        case DebugToolActionTypes.UPDATE:
            return handleDebugToolUpdate(state, action);
        case DebugToolActionTypes.RESET:
            return {};
        default:
            return state;
    }
};
